import React from 'react'
import PropTypes from 'prop-types'
import { buttons } from '../../../helpers/const'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Header from '../../Header'
import Step4 from './Step4';

class FormContainer extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    stripe_key: PropTypes.string.isRequired,
  };

  state = {
    currentStep: 1, ...this.props
  };

  handleSubmit = (data) => {
    const { currentStep } = this.state;

    this.setState({...this.state, ...data});
    if (currentStep === 1 && this.props.customer && this.props.customer.uid) {
      this.setState(state => ({ currentStep: 3 }))
    } else if (currentStep === 2) {
      this.setState(state => ({ currentStep: 4 }))
    } else {
      this.setState(state => ({ currentStep: state.currentStep + 1 }))
    }
  };

  setStep = (step) => {
    this.setState(state => ({ currentStep: step }))
  };

  render() {
    const { currentUser } = this.props;
    const { currentStep } = this.state;

    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <Header
            buttonText={buttons.persona.text}
            buttonUrl={buttons.persona.url}
            currentUser={currentUser}
          />

          <div className="col-12 md-px3 mx-auto py-110 sm-py4" style={{ maxWidth: '1010px' }}>
            {currentStep === 1 && <Step1
              handleSubmit={this.handleSubmit}
              {...this.state}
            />}
            {currentStep === 2 && <Step2
              handleSubmit={this.handleSubmit}
              {...this.state}
            />}
            {currentStep === 3 && <Step3
              handleSubmit={this.handleSubmit}
              setStep={this.setStep}
              {...this.state}
            />}
            {currentStep === 4 && <Step4
              handleSubmit={this.handleSubmit}
              {...this.state}
            />}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default FormContainer
